export var buildEnv = {
    buildMode: 'release',
    datacenter: 'us',
    sdkVersion: '1.15.3',
};
//# sourceMappingURL=buildEnv.js.map